import { Form, Modal } from "antd";
import React from "react";
import { CreateRadiologyJournalDto } from "../../../api";
import { RadiologyJournalsColumns } from "../form/columns";

interface RadiologyJournalsFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateRadiologyJournal: (values: CreateRadiologyJournalDto) => void;
  organizationId?: string;
}

export const RadiologyJournalForm: React.FC<RadiologyJournalsFormProps> = ({ visible, setVisible, onCreateRadiologyJournal, organizationId }) => {
  const [form] = Form.useForm<CreateRadiologyJournalDto>();

  const onChange = (value: any, additional?: any) => {

    (Object.keys(form.getFieldsValue()) as (keyof CreateRadiologyJournalDto)[]).find((key) => {
      return form.getFieldsValue()[key] === value;
    });

  }

  return (
    <Modal width="60%" open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateRadiologyJournal}>
        {RadiologyJournalsColumns().map(({ title, dataIndex, rules, inputNode }, index) => (
          <Form.Item label={title} name={dataIndex} rules={rules} key={index}>
            {
              React.cloneElement(
                inputNode,
                {
                  onChange: onChange
                }
              )
            }
          </Form.Item>
        ))}
      </Form>
    </Modal>
  );
};
